import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BillingCycle } from '../common/interfaces';
import { getBillingCycleContentKey } from './ContentUtil';
import getPriceQuoteItems from './getPriceQuoteItems';

// Currency code map to locale for all Multi Month countries
var currencyMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 'KOR', 'ko-KO'), 'INR', 'en-IN'), 'TRY', 'tr-TR'), 'MXN', 'es-MX'), 'ZAR', 'en-ZA'), 'GBP', 'en-GB'), 'AUD', 'en-AU'), 'CAD', 'en-CA');

// This is a temporary solution to calculate total price from the monthly base price
// based on the term (1M, 6M, 12M). This will be replaced by a value from the pricing
// service (PRICING-179). This is only for the Multi Month Experiment (CA/AU/GB/IN/TR/MX/ZA/KR)
export var getBasePrice = function getBasePrice(monthlyBasePrice, billingPeriod, currencyCode) {
  // Pull the price from the monthly base price (could include CAD/AUD/$/etc)
  var basePriceMatch = monthlyBasePrice.match(/(\d+)(\.|\,)?(\d+)/);
  if (!basePriceMatch || !currencyCode) {
    return monthlyBasePrice;
  }
  var basePriceString = basePriceMatch[0];
  // Replace comma with decimal if comma format is used (eg: ₺310,06)
  var priceWithoutLastComma = basePriceString.replace(/\,(\d\d)$/, '.$1');
  // Remove any commas used as separators (eg: 26,660)
  var priceAsNumber = parseFloat(priceWithoutLastComma.replace(',', ''));
  var formatter = new Intl.NumberFormat(currencyMap[currencyCode], {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  var formatterNoDecimal = new Intl.NumberFormat(currencyMap[currencyCode], {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  if (billingPeriod == BillingCycle.SEMI_ANNUAL) {
    // If whole number, return with no decimal places (eg: KOR)
    var newBasePriceString = priceAsNumber % 1 == 0 ? formatterNoDecimal.format(priceAsNumber * 6) : formatter.format(priceAsNumber * 6);
    return monthlyBasePrice.replace(basePriceString, newBasePriceString);
  }
  if (billingPeriod == BillingCycle.ANNUAL) {
    // If whole number, return with no decimal places (eg: KOR)
    var _newBasePriceString = priceAsNumber % 1 == 0 ? formatterNoDecimal.format(priceAsNumber * 12) : formatter.format(priceAsNumber * 12);
    return monthlyBasePrice.replace(basePriceString, _newBasePriceString);
  }
  return monthlyBasePrice;
};
var getPriceSubtext = function getPriceSubtext(totalItemPrice, billingCycleLong) {
  return billingCycleLong.replace('__${price}__', totalItemPrice);
};
var getTagText = function getTagText(totalSavings, badgeSave) {
  return totalSavings === '0' ? undefined : badgeSave.replace('${savings}', totalSavings);
};
var getUpsellText = function getUpsellText(optionPreference, bestValueText) {
  return optionPreference !== null && optionPreference !== void 0 && optionPreference.bestValue ? bestValueText : undefined;
};
var getProductVariation = function getProductVariation(_ref, _ref2, currencyCode) {
  var itemDetails = _ref.itemDetails,
    monthlyPrice = _ref.monthlyPrice,
    monthlyBasePrice = _ref.monthlyBasePrice,
    optionPreference = _ref.optionPreference,
    billingPeriod = _ref.billingPeriod,
    totalItemPrice = _ref.totalItemPrice,
    totalSavings = _ref.totalSavings,
    productId = _ref.pricingKey.productId,
    pricingLogId = _ref.pricingLogId,
    totalSavingsPercentage = _ref.totalSavingsPercentage;
  var billingCycleLong = _ref2.billingCycleLong,
    badgeSave = _ref2.badgeSave,
    bestValueText = _ref2.bestValueText,
    ctaMultiMonth = _ref2.ctaMultiMonth,
    cardTitle = _ref2.cardTitle;
  var billingCycleContentKey = getBillingCycleContentKey(billingPeriod);
  return {
    id: itemDetails.externalId,
    catalogItemId: itemDetails.id,
    pricingLogId: pricingLogId,
    price: monthlyPrice,
    monthlyBasePrice: monthlyBasePrice,
    priceSubtext: getPriceSubtext(totalItemPrice, billingCycleLong[billingCycleContentKey]),
    tagText: getTagText(totalSavings, badgeSave),
    title: cardTitle && cardTitle[billingCycleContentKey],
    upsellText: getUpsellText(optionPreference, bestValueText),
    defaultSelected: !!(optionPreference !== null && optionPreference !== void 0 && optionPreference.bestValue),
    totalSavings: totalSavings,
    totalSavingsPercentage: totalSavingsPercentage,
    ctaCopy: ctaMultiMonth && ctaMultiMonth[billingCycleContentKey],
    totalItemPrice: totalItemPrice,
    billingPeriod: billingPeriod,
    productId: productId,
    basePrice: monthlyBasePrice && getBasePrice(monthlyBasePrice, billingPeriod, currencyCode)
  };
};

/**
 * Returns formatted product variations for the given product
 **/
var getProductVariations = function getProductVariations(pricing, content, currencyCode) {
  return getPriceQuoteItems(pricing).sort().map(function (priceQuoteItem) {
    return getProductVariation(priceQuoteItem, content, currencyCode);
  });
};
export default getProductVariations;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getProductVariations.js
// module id = 4130
// module chunks = 11